import * as React from 'react';
import {NotificationManager} from 'react-notifications';
import {CREATE} from '../fetchApi/types';
import {withDataProvider} from '../fetchApi/dataProvider';
import {compose} from 'redux';
import {DataProvider} from '../fetchApi/tsTypes';
import {RouteChildrenProps, withRouter} from 'react-router-dom';

export interface InjectionCreateProps {
    save: Function;
    loading: boolean;
    resource: string;
}

interface CreateProps {
    resource: string;
    redirect?: string;
    state?: object;
}

interface InternalCreateProps extends CreateProps, RouteChildrenProps {
    dataProvider: DataProvider;
    children?: React.ReactNode;
}

const Create: React.FunctionComponent<InternalCreateProps> = ({
    children,
    resource,
    dataProvider,
    history,
    ...rest
}: InternalCreateProps) => {
    const [loading, changeLoading] = React.useState(false);

    const save = (values: object, redirect?: string): void => {
        changeLoading(true);
        dataProvider(CREATE, resource, {data: values})
            .then((element) => {

                NotificationManager.success('Element created', '', 1500);

                if (redirect === 'edit' && element?.data?.id) {
                    redirect = element.data.id;
                }

                const resultRedirect = redirect || `/${resource}`;
                history.push({pathname: resultRedirect, state: rest.state});
            })
            .catch((e) => {
                console.error(e);
                NotificationManager.error(e.message);
            })
            .finally(() => {
                changeLoading(false);
            });
    };

    return (
        <React.Fragment>
            {React.Children.map(children, (child: any) => {
                return React.cloneElement(child, {
                    save,
                    loading,
                    resource,
                    ...rest,
                });
            })}
        </React.Fragment>
    );
};

const EnhancedCreate: React.FunctionComponent<CreateProps> = compose(withDataProvider, withRouter)(Create);

export default EnhancedCreate;
